import React, { useState } from "react";
import "../styles/Contact.css";
import Footer from "../components/Footer";

const Contact = () => {
  const [faqOpen, setFaqOpen] = useState(null);
  const toggleFAQ = (i) => setFaqOpen((prev) => (prev === i ? null : i));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    const data = {
      name: formData.get("name"),
      phone: formData.get("phone"),
      email: formData.get("email"),
      service: formData.get("service"),
      message: formData.get("message"),
    };

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbwgdLZKZYTkU9O0k_uE35Sn-wNjobo_lqsN5rdyY5ZHR9D0cUSAfjB-IwOpkuXi3pim/exec", // Replace with your deployed URL
        {
          method: "POST",
          mode: "no-cors", // Important for CORS bypass
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // With no-cors, response will be empty, so just assume success
      alert("✅ Thanks! Your message has been submitted.");
      e.target.reset();

    } catch (err) {
      console.error("Fetch error:", err);
      alert("⚠️ Error submitting form. Please try later.");
    }
  };





  return (
    <div className="contact-page">
      {/* HERO */}
      <header className="contact-hero">
        <div className="contact-hero-icon" aria-hidden>
          📞
        </div>
        <h1 className="contact-title">Get in Touch</h1>
        <p className="contact-subtitle">
          We’re here to help—reach out for appointments, questions, or support.
        </p>
      </header>

      {/* MAIN GRID */}
      <main className="contact-grid">
        {/* FORM CARD */}
        <section
          className="contact-card contact-form"
          aria-labelledby="contact-form-heading"
        >
          <h2 id="contact-form-heading" className="section-heading">
            Send us a Message
          </h2>
          <p className="section-subtext">
            We usually respond within one business day.
          </p>

          <form onSubmit={handleSubmit} noValidate>
            <div className="form-row">
              <div className="form-field">
                <label htmlFor="name">Full Name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Your name"
                  required
                />
              </div>
              <div className="form-field">
                <label htmlFor="phone">Phone</label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  placeholder="+91 98xxxxxxx"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-field">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="you@example.com"
                  required
                />
              </div>
              <div className="form-field">
                <label htmlFor="service">Service</label>
                <select id="service" name="service" defaultValue="">
                  <option value="" disabled>
                    Choose a service
                  </option>
                  <option>Medical Rehabilitation</option>
                  <option>Psychiatric Rehabilitation</option>
                  <option>Special School (NDD)</option>
                  <option>Vocational Rehabilitation</option>
                  <option>Physiotherapy</option>
                  <option>Occupational Therapy</option>
                  <option>Speech Therapy</option>
                  <option>Psychology</option>
                </select>
              </div>
            </div>

            <div className="form-field">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                placeholder="How can we help?"
                required
              />
            </div>

            <button type="submit" className="btn-primary">
              Submit
            </button>
          </form>
        </section>

        {/* DETAILS + MAP CARD */}
        <aside
          className="contact-card contact-details"
          aria-labelledby="contact-details-heading"
        >
          <h2 id="contact-details-heading" className="section-heading">
            Contact Details
          </h2>

          <ul className="details-list">
            <li>
              <span aria-hidden>📍</span>
              <div>
                Dr. Bharathi Rao’s Advanced Comprehensive Rehabilitation Services
                <br />
                Hyderabad, Telangana
              </div>
            </li>
            <li>
              <span aria-hidden>📱</span>
              <a href="tel:+917207996776">+91 72079 96776</a>
            </li>
            <li>
              <span aria-hidden>✉️</span>
              <a href="mailto:info@drbharathiraos.com">info@drbharathiraos.com</a>
            </li>
            <li>
              <span aria-hidden>🕒</span>
              <div>
                Mon–Sat: 9:00 AM – 7:00 PM
                <br />
                Sun: Closed
              </div>
            </li>
          </ul>

          <div className="map-card">
            <iframe
              title="Google Map"
              className="map-embed"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.438759805634!2d78.72350581480001!3d17.331445485998557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb0b3238ac84b3%3A0x8b9b58e2f5cbe1ce!2sDr.Bharathi%20Rao's%20Advanced%20Comprehensive%20Rehabilitation%20Services!5e0!3m2!1sen!2sin!4v1617774474890!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </aside>
      </main>

      {/* FAQ */}
      <section className="contact-faq" aria-labelledby="faq-heading">
        <h2 id="faq-heading" className="section-heading center">FAQs</h2>

        <div className="faq-grid">
          {[
            {
              q: "Do I need a referral for an appointment?",
              a: "No referral is required. You can book directly using the form or by calling us.",
            },
            {
              q: "Do you offer home-based therapy?",
              a: "Yes, we provide virtual and home-based sessions for eligible cases.",
            },
            {
              q: "What payment options are available?",
              a: "We accept cash, UPI, and most major bank transfers. Please call for specifics.",
            },
            {
              q: "Is parking available at the center?",
              a: "Yes, visitor parking is available on-site.",
            },
          ].map((item, i) => {
            const open = faqOpen === i;
            return (
              <div className={`faq-item ${open ? "open" : ""}`} key={i}>
                <button
                  className="faq-q"
                  onClick={() => toggleFAQ(i)}
                  aria-expanded={open}
                  aria-controls={`faq-${i}`}
                >
                  <span>{item.q}</span>
                  <span className="faq-icon" aria-hidden>
                    {open ? "▲" : "▼"}
                  </span>
                </button>
                <div
                  id={`faq-${i}`}
                  className="faq-a"
                  style={{ maxHeight: open ? "180px" : "0px" }}
                >
                  <p>{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
